import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { NewsStream } from '@ifeng-fe/news-stream';
import '@ifeng-fe/news-stream/lib/NewsStream/style/news-stream-global.css';

class HeadLines extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        const newsStreamProps = {
            content, // 截取信息流条20条
            columnId: '286171', // 加载更多时的碎片ID
            isEnd: true, // 是否已显示全部，true：已显示全部，false：还有数据
            isDisplaySource: true, // 是否显示新闻来源
            repeatedID: [], // 信息流内用于排重的id
            ad: [{}],
            dataTypeName: 'recommendFragment',
        };

        return (
            <div className={styles.headLines}>
                <NewsStream {...newsStreamProps} />
            </div>
        );
    }
}

export default errorBoundary(HeadLines);
